import { persist } from 'zustand/middleware';
import create from 'zustand';
import { tableColumns } from '../components/table/ColumnDefs';

type TableSection = 'main' | 'expanded';

type ColumnOrderState = {
   orders: Record<TableSection, string[]>;
   columnsMoveable: boolean;
   reorder: (section: TableSection, movedAccessorKey: string, targetAccessorKey: string) => void;
   resetOrder: () => void;
   toggleMoveableColumns: () => void;
};

const getDefaultOrders = (): Record<TableSection, string[]> => ({
   main: tableColumns.main.map((c) => c.accessorKey),
   expanded: tableColumns.expanded.map((c) => c.accessorKey),
});

export const useColumnOrderState = create<ColumnOrderState>()(
   persist(
      (set) => ({
         orders: getDefaultOrders(),
         columnsMoveable: false,
         reorder: (section, movedAccessorKey, targetAccessorKey) =>
            set((state) => {
               const next = [...state.orders[section]];
               const fromIndex = next.indexOf(movedAccessorKey);
               const toIndex = next.indexOf(targetAccessorKey);

               if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
                  return state;
               }

               const [moved] = next.splice(fromIndex, 1);
               const insertIndex = fromIndex < toIndex ? toIndex - 1 : toIndex;
               next.splice(insertIndex, 0, moved);
               return { orders: { ...state.orders, [section]: next } };
            }),
         resetOrder: () => set({ orders: getDefaultOrders() }),
         toggleMoveableColumns: () => set((state) => ({ columnsMoveable: !state.columnsMoveable })),
      }),
      { name: 'column-order' }
   )
);
